"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _style = require("./style");

var Notification = function Notification(_ref) {
  var arrow = _ref.arrow,
      className = _ref.className,
      content = _ref.content,
      icon = _ref.icon,
      flexDirection = _ref.flexDirection,
      testId = _ref.testId,
      title = _ref.title,
      type = _ref.type,
      visible = _ref.visible,
      width = _ref.width;
  return _react["default"].createElement(_style.Container, {
    arrow: arrow,
    className: className,
    "data-test-id": testId,
    flexDirection: flexDirection,
    visible: visible,
    type: type,
    width: width
  }, title && _react["default"].createElement(_style.Title, {
    type: type
  }, title), content && _react["default"].createElement(_style.Content, {
    type: type
  }, content), icon && _react["default"].createElement(_style.IconStyled, {
    icon: icon,
    size: 24,
    color: type ? _palette.palette[type] : _palette.palette.bobBlack
  }));
};

Notification.propTypes = {
  arrow: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]).isRequired,
  icon: _propTypes["default"].string,
  flexDirection: _propTypes["default"].string,
  testId: _propTypes["default"].string,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  type: _propTypes["default"].string,
  visible: _propTypes["default"].bool,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Notification.defaultProps = {
  arrow: false,
  className: '',
  icon: null,
  flexDirection: 'row',
  testId: 'notification',
  title: undefined,
  type: null,
  visible: true,
  width: undefined
};
var _default = Notification;
exports["default"] = _default;